class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio > 0){
          if(item.getAttribute('id')) {
            $(`[data-id="${item.getAttribute('id')}"]`).animate({'opacity': '1'});
          } else {
            $(`.js-bg-target`).animate({'opacity': '0'});
          }

          if(item.classList.contains('sakura')) {
            $('.js-target-sakuta').addClass('is-active');
          }
        } else {
          $(`[data-id="${item.getAttribute('id')}"]`).animate({'opacity': '0'});
        }
      });
    });
    const inviewItem = document.querySelectorAll('.js-bg-change');
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });

    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var api = url || "https://graph.facebook.com/v9.0/17841462611577192?fields=name,media.limit(9){caption,media_url,thumbnail_url,permalink,like_count,comments_count,media_type}&access_token=EAAQIftym9xUBOZCoveBYd7kMhzNRMjnQ8BlnF1jRTA53uq2lbfOzPZAa4v7th5j6LUuaqQKONSoRFlHIo6i2VbHWp09NYqk6rLgZB6566l1zwcR7GZBFTa7ch4RhyyTmF1CHqPrLrk8sPO14QO4exkbTprWQRZACBcjVJIZBUSIoi4qqBgzFGM57rtjoi4iEZCoJnQugzwZD";
    fetch(api).then(function (response) {
      return response.json();
    }).then(function (data) {
      if (data.media !== undefined) {
        _createTile(data.media.data, url === '' ? true : false);
      }
    }).catch(function (error) {
      console.log(error);
    });
    
    function _createTile(media, insert) {
      var container = document.querySelector('.js-insta-api');
      var fragment = document.createDocumentFragment();
      media.forEach(function (item, i) {
        var link = document.createElement('a');
        link.setAttribute('href', item.permalink);
        link.setAttribute('target', '_blank');
        link.classList.add('c-hover');
        var img = document.createElement('img');
        img.src = item.thumbnail_url || item.media_url;
        link.appendChild(img);
        fragment.appendChild(link);
      });
    
      if (insert) {
        container.insertBefore(fragment, null);
      } else {
        container.appendChild(fragment);
      }
    }
  }
}
